import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "tagsWrapper activeBtn"
}
const _hoisted_3 = { class: "activeBtn" }
const _hoisted_4 = {
  key: 0,
  class: "multiSelectSearch-container"
}
const _hoisted_5 = {
  key: 2,
  class: "item-display notFound"
}
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_CheckBox = _resolveComponent("CheckBox")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-container activeBtn", { disabled: _ctx.disabled }]),
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)))
  }, [
    _createElementVNode("img", {
      class: "icon activeBtn",
      src: _ctx.icon,
      alt: "dropdown"
    }, null, 8, _hoisted_1),
    (_ctx.selectedItems.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputDisplay(_ctx.selectedItems, _ctx.listTotal || _ctx.list), (selectField) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "selectTag activeBtn",
              key: selectField
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(selectField), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass(["label activeBtn", (_ctx.active || _ctx.selectedItems) && 'label-active'])
    }, _toDisplayString(_ctx.label), 3),
    (_ctx.active && !_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["drop-container", {'withSearch' : _ctx.withSearch, 'drop-container-bigger': _ctx.dropDownBigger}])
        }, [
          (_ctx.withSearch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_TextInput, {
                  label: _ctx.$t('title.search'),
                  modelValue: _ctx.searchModel,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchModel) = $event)),
                  onChange: _ctx.searchModel.set
                }, null, 8, ["label", "modelValue", "onChange"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.list.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["item-display", this.selectedClass('all')]),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.toggleSelectAll && this.toggleSelectAll(...args)))
              }, [
                _createElementVNode("span", null, [
                  _createVNode(_component_CheckBox, {
                    label: _ctx.list.length === _ctx.listTotal?.length ? _ctx.$t('all') : _ctx.$t('allDisplayed'),
                    checked: _ctx.isAllSelected
                  }, null, 8, ["label", "checked"])
                ])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.list.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('search.notFound')), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item-display", this.selectedClass(item)]),
              onClick: () => this.toggleCheck(item),
              key: index
            }, [
              _createElementVNode("span", null, [
                _createVNode(_component_CheckBox, {
                  label: _ctx.checkboxDisplay(item),
                  checked: _ctx.isChecked(item)
                }, null, 8, ["label", "checked"])
              ])
            ], 10, _hoisted_6))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}